import React from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const FreezeLifecycleTable = () => {
  const {
    data = [],
    colHeaders = [],
    columns = [],
    links = [],
    rawDataLink
  } = useSelector((state) => state.freezeLifecycle.chartsData.table || {});

  return (
    <TableWithCustomSearch
      fileName="freeze-lifecycle"
      data={data}
      colHeaders={colHeaders}
      columns={columns}
      links={links}
      rawDataLink={rawDataLink}
    />
  );
};

export default FreezeLifecycleTable;
